
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.76 28a2.397 2.397 0 01-2.398 2.397A2.397 2.397 0 0118.966 28a2.397 2.397 0 012.396-2.397A2.397 2.397 0 0123.76 28zm-10.726 0a2.397 2.397 0 01-2.396 2.397A2.397 2.397 0 018.24 28a2.397 2.397 0 012.397-2.397A2.397 2.397 0 0113.034 28zm10.725-8a2.397 2.397 0 01-2.397 2.397A2.397 2.397 0 0118.966 20a2.397 2.397 0 012.396-2.397A2.397 2.397 0 0123.76 20zm-10.725 0a2.397 2.397 0 01-2.396 2.397A2.397 2.397 0 018.24 20a2.397 2.397 0 012.397-2.397A2.397 2.397 0 0113.034 20zM23.76 4a2.397 2.397 0 01-2.397 2.397A2.397 2.397 0 0118.966 4a2.397 2.397 0 012.396-2.397A2.397 2.397 0 0123.76 4zM13.034 4a2.397 2.397 0 01-2.396 2.397A2.397 2.397 0 018.24 4a2.397 2.397 0 012.397-2.397A2.397 2.397 0 0113.034 4zm10.725 8a2.397 2.397 0 01-2.397 2.397A2.397 2.397 0 0118.966 12a2.397 2.397 0 012.396-2.397A2.397 2.397 0 0123.76 12zm-10.725 0a2.397 2.397 0 01-2.396 2.397A2.397 2.397 0 018.24 12a2.397 2.397 0 012.397-2.397A2.397 2.397 0 0113.034 12z"}})])
          )
        }
      }
    